module.exports = __webpack_public_path__ + "static/media/2 - Tierra Whack - Only Child.ab757afe.mp3";